import { Link } from "react-router-dom";
import { resolveImg } from "@/components/admin/ProductsTab";

export default function CategoryCard({ category, index = 0 }) {
  const tilt = index % 3 === 0 ? "-rotate-1" : index % 3 === 1 ? "rotate-1" : "-rotate-[2deg]";
  return (
    <Link
      to={`/shop/${category.slug}`}
      data-testid={`category-card-${category.slug}`}
      className={`group block nb-card ${tilt}`}
      style={{ background: category.accent }}
    >
      <div className="relative aspect-square overflow-hidden border-b-[3px] border-black">
        <img
          src={resolveImg(category.image)}
          alt={category.name}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
      </div>
      <div className="p-4 flex items-center justify-between bg-white">
        <span className="font-display font-black uppercase text-base md:text-lg tracking-tight">{category.name}</span>
        <span className="w-9 h-9 rounded-full bg-black text-white flex items-center justify-center font-black group-hover:rotate-45 transition-transform">→</span>
      </div>
    </Link>
  );
}
